import {all, call, put, takeLatest} from '@redux-saga/core/effects';
import {acceptLegalTerms, getLegalDocumentText} from 'Core/api/legalAcceptanceApi';
import {
  acceptAgreements,
  getLegalAgreementsText,
  LegalAcceptanceActionType,
  LegalAgreementDictionary,
  loadLegalAgreementsText,
} from 'Core/ducks/legalAcceptance';
import {initiateTokenRefresh, toggleRefreshSpinner} from "Core/ducks/refreshToken";
import {AsyncResult, fromResult} from 'Core/models/Async';
import {LegalDocumentText} from 'Core/models/LegalDocument';
import CoreRouteConstants from 'Core/CoreRouteConstants';
import {setRefreshReRouteOptions} from "Core/refreshTokenUtilityMethods";
import * as E from 'fp-ts/lib/Either';

function* getDocument(id: string) {
  const legalTextEither: AsyncResult<LegalDocumentText> = yield call(getLegalDocumentText, id);

  if (E.isRight(legalTextEither)) {
    return {
      [id]: legalTextEither.right.legalText,
    };
  } else {
    return null;
  }
}

export function* getLegalAgreementFromApi(action: ReturnType<typeof getLegalAgreementsText>) {
  const legalTexts: LegalAgreementDictionary[] = yield all(action.payload.ids.map(getDocument));
  const textDictionary = legalTexts.reduce(Object.assign, {});
  yield put(loadLegalAgreementsText(fromResult(textDictionary)));
}

export function* getLegalAcceptanceTextSaga() {
  yield takeLatest(LegalAcceptanceActionType.GET_LEGAL_AGREEMENT_TEXT, getLegalAgreementFromApi);
}

export function* acceptLegalAgreements(action: ReturnType<typeof acceptAgreements>) {
  yield put(toggleRefreshSpinner(true, `Accepting Legal Terms...`));
  yield call(acceptLegalTerms, action.payload.userId, action.payload.ids);
  setRefreshReRouteOptions(true, CoreRouteConstants.DASHBOARD);
  yield put(initiateTokenRefresh());
}

export function* acceptLegalAgreementsSaga() {
  yield takeLatest(LegalAcceptanceActionType.ACCEPT, acceptLegalAgreements);
}

export default function*() {
  yield all([getLegalAcceptanceTextSaga(), acceptLegalAgreementsSaga()]);
}
